const environment = {
  nodeApiUrl: process.env.REACT_APP_NODE_API_URL,
  etokenApiUrl: process.env.REACT_APP_ETOKEN_API_URL,
};

export default environment;